// import React, { useEffect, useMemo, useState } from "react";
// import "../../styles/ChatbotWidget.css";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import rehypeExternalLinks from "rehype-external-links";

// import fullscreenIcon from "../../assets/icons/fullscreen_icon.png";
// import trashIcon from "../../assets/icons/trash_icon.png";
// import downloadIcon from "../../assets/icons/download_icon.png";
// import imageIcon from "../../assets/icons/image_icon2.png";
// import aiAvatar from "../../assets/icons/ai_assistant.png";
// import userAvatar from "../../assets/icons/user_avatar.png";
// import { v4 as uuidv4 } from "uuid";

// function linkify(text) {
//   const urlPattern = /(https?:\/\/[^\s]+)/g;
//   return text.replace(urlPattern, (url) => `[${url}](${url})`);
// }

// export default function ChatbotWidget({ clinicId, clinicName = "Clinic"}) {
//   const API_BASE = process.env.REACT_APP_API_BASE_URL;

//   const [isThinking, setIsThinking] = useState(false);
//   const [messages, setMessages] = useState([
//     {
//       sender: "ai",
//       text: `My name is Lisa. Thank you for reaching out to ${clinicName}. How can I help you today?`,
//     },
//   ]);
//   const [input, setInput] = useState("");

//   // ✅ Session state
//   const [sessionId, setSessionId] = useState(null);

//   // ✅ Stable visitor id per browser
//   const visitorId = useMemo(() => {
//     const k = "olumis_visitor_id";
//     let id = localStorage.getItem(k);
//     if (!id) {
//       id = uuidv4();
//       localStorage.setItem(k, id);
//     }
//     return id;
//   }, []);

//   // ✅ Create or reuse a session per clinic
//   useEffect(() => {
//     async function initSession() {
//       if (!clinicId) return;
//       if (!API_BASE) {
//         console.warn("Missing REACT_APP_API_BASE_URL");
//         return;
//       }

//       const storageKey = `olumis_session_${clinicId}`;
//       const existing = localStorage.getItem(storageKey);
//       if (existing) {
//         setSessionId(existing);
//         return;
//       }

//       try {
//         const res = await fetch(`${API_BASE}/chatlog/session`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             clinic_id: clinicId,
//             visitor_id: visitorId,
//             channel: "standalone_link",
//             metadata: { page: window.location.href },
//           }),
//         });

//         if (!res.ok) {
//           const text = await res.text();
//           throw new Error(`Create session failed: HTTP ${res.status}: ${text}`);
//         }

//         const data = await res.json();
//         localStorage.setItem(storageKey, data.session_id);
//         setSessionId(data.session_id);
//       } catch (e) {
//         console.error("Failed to create session:", e);
//         // session 创建失败不阻塞聊天，但你会失去日志
//         setSessionId(null);
//       }
//     }

//     initSession();
//   }, [clinicId, visitorId, API_BASE]);

//   // ✅ helper: log message (doesn't block chat)
//   const logMessage = async ({ role, content, sources = null, confidence_score = null, model = null, meta = null }) => {
//     if (!API_BASE || !clinicId || !sessionId) return;

//     try {
//       const res = await fetch(`${API_BASE}/chatlog/message`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           clinic_id: clinicId,
//           session_id: sessionId,
//           role,
//           content,
//           sources,
//           confidence_score,
//           model,
//           meta,
//         }),
//       });

//       if (!res.ok) {
//         const text = await res.text();
//         console.warn("Log message failed:", res.status, text);
//       }
//     } catch (e) {
//       console.warn("Log message error:", e);
//     }
//   };

//   const handleSend = async () => {
//     if (!input) return;
//     if (!sessionId) {
//       setMessages((prev) => [...prev, { sender: "ai", text: "Session not ready yet. Please try again in a second." }]);
//       return;
//     }
  
//     const textToSend = input;
//     setMessages((prev) => [...prev, { sender: "user", text: textToSend }]);
//     setInput("");
//     setIsThinking(true);
  
//     try {
//       const res = await fetch(`${API_BASE}/chat/message`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           clinic_id: clinicId,
//           session_id: sessionId,
//           query: textToSend,
//           top_k: 6,
//           min_score: 0.35,
//         }),
//       });
  
//       if (!res.ok) {
//         const text = await res.text();
//         throw new Error(`HTTP ${res.status}: ${text}`);
//       }
  
//       const data = await res.json();
//       const answerText = data?.answer || "No answer returned.";
  
//       setMessages((prev) => [...prev, { sender: "ai", text: answerText }]);
//     } catch (err) {
//       console.error("Error fetching AI response:", err);
//       const errMsg = `Sorry — I couldn’t reach the server. (${err.message})`;
//       setMessages((prev) => [...prev, { sender: "ai", text: errMsg }]);
//     } finally {
//       setIsThinking(false);
//     }
//   };
  

//   const handleDeleteLastMessage = () => {
//     setMessages((prev) => prev.slice(0, -1));
//   };

//   const handleToggleFullscreen = () => {
//     const elem = document.documentElement;
//     if (!document.fullscreenElement) {
//       elem.requestFullscreen();
//     } else {
//       document.exitFullscreen();
//     }
//   };

//   const handleDownloadChat = () => {
//     const text = messages.map((m) => `${m.sender.toUpperCase()}: ${m.text}`).join("\n\n");
//     const blob = new Blob([text], { type: "text/plain" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "chat_history.txt";
//     link.click();
//   };

 
//   const markdownComponents = {
//     a: ({ href, children }) => (
//       <a
//         href={href}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="chat-link"
//       >
//         {children}
//       </a>
//     ),
//   };


//   return (
//     <div className="chatbot-box">
//       <div className="chat-header">
//         <span className="chat-title">{clinicName}</span>
//         <div className="chat-icons">
//           <button title="Download Chat" onClick={handleDownloadChat}>
//             <img src={downloadIcon} alt="Download" className="chat-icon" />
//           </button>
//           <button title="Full Screen" onClick={handleToggleFullscreen}>
//             <img src={fullscreenIcon} alt="Full Screen" className="chat-icon" />
//           </button>
//           <button title="Clear Chat" onClick={handleDeleteLastMessage}>
//             <img src={trashIcon} alt="Clear Chat" className="chat-icon" />
//           </button>
//         </div>
//       </div>

//       <div className="chat-messages">
//         {messages.map((m, i) => (
//           <div key={i} className={`message-row ${m.sender}`}>
//             {m.sender === "ai" && (
//               <>
//                 <img src={aiAvatar} className="ai-avatar" alt="AI Avatar" />
//                 <div className={`message ${m.sender}`}>
//                 <ReactMarkdown
//                   remarkPlugins={[remarkGfm]}
//                   rehypePlugins={[
//                     [rehypeExternalLinks, { target: "_blank", rel: ["noopener", "noreferrer"] }],
//                   ]}
//                   components={markdownComponents}
//                 >
//                   {linkify(m.text)}
//                 </ReactMarkdown>
//               </div>
//               </>
//             )}

//             {m.sender === "user" && (
//               <>
//                 <div className={`message ${m.sender}`}>
//                 <ReactMarkdown
//                   remarkPlugins={[remarkGfm]}
//                   rehypePlugins={[
//                     [rehypeExternalLinks, { target: "_blank", rel: ["noopener", "noreferrer"] }],
//                   ]}
//                   components={markdownComponents}
//                 >
//                   {linkify(m.text)}
//                 </ReactMarkdown>
//                 </div>
//                 <img src={userAvatar} className="user-avatar" alt="User Avatar" />
//               </>
//             )}
//           </div>
//         ))}

//         {isThinking && (
//           <div className="message-row ai">
//             <img src={aiAvatar} className="ai-avatar" alt="AI Avatar" />
//             <div className="message ai typing-indicator">
//               <span>Typing</span>
//               <span className="dot dot1">.</span>
//               <span className="dot dot2">.</span>
//               <span className="dot dot3">.</span>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="chat-input">
//         <input
//           type="file"
//           accept="image/*"
//           id="imageUpload"
//           style={{ display: "none" }}
//           onChange={(e) => {
//             const file = e.target.files[0];
//             if (file) {
//               const url = URL.createObjectURL(file);
//               setMessages((prev) => [...prev, { sender: "user", text: "[Image uploaded]", image: url }]);
//               // Optional: log upload event
//               logMessage({ role: "user", content: "[Image uploaded]", meta: { image: true, filename: file.name } });
//             }
//           }}
//         />

//         <button
//           title="Upload Image"
//           className="image-upload-btn"
//           onClick={() => document.getElementById("imageUpload").click()}
//         >
//           <img src={imageIcon} alt="Upload" className="chat-icon2" />
//         </button>

//         <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Type a message here" />

//         {/* ✅ Disable send if session not ready */}
//         <button onClick={handleSend} disabled={isThinking || !sessionId}>
//         ➤
//         </button>
//       </div>

//       <div className="chat-footer">
//         Powered by Olumis AI
//         {/* Optional debug */}
//         {/* <span style={{ marginLeft: 8, fontSize: 10, opacity: 0.6 }}>{sessionId ? "session ok" : "no session"}</span> */}
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import "../../styles/ChatbotWidget.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeExternalLinks from "rehype-external-links";

import fullscreenIcon from "../../assets/icons/fullscreen_icon.png";
import trashIcon from "../../assets/icons/trash_icon.png";
import downloadIcon from "../../assets/icons/download_icon.png";
import imageIcon from "../../assets/icons/image_icon2.png";
import aiAvatar from "../../assets/icons/ai_assistant.png";
import userAvatar from "../../assets/icons/user_avatar.png";
import { v4 as uuidv4 } from "uuid";

function linkify(text) {
  const urlPattern = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlPattern, (url) => `[${url}](${url})`);
}

export default function ChatbotWidget({ clinicId, clinicName = "Clinic" }) {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const isEmbed = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("embed") === "1";
  }, []);

  const [isThinking, setIsThinking] = useState(false);
  const [messages, setMessages] = useState([
    {
      sender: "ai",
      text: `My name is Lisa. Thank you for reaching out to ${clinicName}. How can I help you today?`,
    },
  ]);
  const [input, setInput] = useState("");
  const [sessionId, setSessionId] = useState(null);

  const visitorId = useMemo(() => {
    const k = "olumis_visitor_id";
    let id = localStorage.getItem(k);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(k, id);
    }
    return id;
  }, []);

  useEffect(() => {
    async function initSession() {
      if (!clinicId) return;
      if (!API_BASE) {
        console.warn("Missing REACT_APP_API_BASE_URL");
        return;
      }

      const storageKey = `olumis_session_${clinicId}`;
      const existing = localStorage.getItem(storageKey);
      if (existing) {
        setSessionId(existing);
        return;
      }

      try {
        const res = await fetch(`${API_BASE}/chatlog/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            clinic_id: clinicId,
            visitor_id: visitorId,
            channel: isEmbed ? "widget_embed" : "standalone_link",
            metadata: { page: window.location.href },
          }),
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Create session failed: HTTP ${res.status}: ${text}`);
        }

        const data = await res.json();
        localStorage.setItem(storageKey, data.session_id);
        setSessionId(data.session_id);
      } catch (e) {
        console.error("Failed to create session:", e);
        setSessionId(null);
      }
    }

    initSession();
  }, [clinicId, visitorId, API_BASE, isEmbed]);

  const logMessage = async ({
    role,
    content,
    sources = null,
    confidence_score = null,
    model = null,
    meta = null,
  }) => {
    if (!API_BASE || !clinicId || !sessionId) return;

    try {
      const res = await fetch(`${API_BASE}/chatlog/message`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clinic_id: clinicId,
          session_id: sessionId,
          role,
          content,
          sources,
          confidence_score,
          model,
          meta,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        console.warn("Log message failed:", res.status, text);
      }
    } catch (e) {
      console.warn("Log message error:", e);
    }
  };

  const handleSend = async () => {
    if (!input) return;
    if (!sessionId) {
      setMessages((prev) => [
        ...prev,
        { sender: "ai", text: "Session not ready yet. Please try again in a second." },
      ]);
      return;
    }

    const textToSend = input;
    setMessages((prev) => [...prev, { sender: "user", text: textToSend }]);
    setInput("");
    setIsThinking(true);

    try {
      const res = await fetch(`${API_BASE}/chat/message`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clinic_id: clinicId,
          session_id: sessionId,
          query: textToSend,
          top_k: 6,
          min_score: 0.35,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      const data = await res.json();
      const answerText = data?.answer || "No answer returned.";

      setMessages((prev) => [...prev, { sender: "ai", text: answerText }]);
    } catch (err) {
      console.error("Error fetching AI response:", err);
      const errMsg = `Sorry — I couldn’t reach the server. (${err.message})`;
      setMessages((prev) => [...prev, { sender: "ai", text: errMsg }]);
    } finally {
      setIsThinking(false);
    }
  };

  const handleDeleteLastMessage = () => {
    setMessages((prev) => prev.slice(0, -1));
  };

  const handleToggleFullscreen = () => {
    const elem = document.documentElement;
    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const handleDownloadChat = () => {
    const text = messages.map((m) => `${m.sender.toUpperCase()}: ${m.text}`).join("\n\n");
    const blob = new Blob([text], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "chat_history.txt";
    link.click();
  };

  const markdownComponents = {
    a: ({ href, children }) => (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="chat-link"
      >
        {children}
      </a>
    ),
  };

  return (
    <div className={`chatbot-box ${isEmbed ? "embed-mode" : "standalone-mode"}`}>
      <div className="chat-header">
        <span className="chat-title">{clinicName}</span>
        <div className="chat-icons">
          <button title="Download Chat" onClick={handleDownloadChat}>
            <img src={downloadIcon} alt="Download" className="chat-icon" />
          </button>
          <button title="Full Screen" onClick={handleToggleFullscreen}>
            <img src={fullscreenIcon} alt="Full Screen" className="chat-icon" />
          </button>
          <button title="Clear Chat" onClick={handleDeleteLastMessage}>
            <img src={trashIcon} alt="Clear Chat" className="chat-icon" />
          </button>
        </div>
      </div>

      <div className="chat-messages">
        {messages.map((m, i) => (
          <div key={i} className={`message-row ${m.sender}`}>
            {m.sender === "ai" && (
              <>
                <img src={aiAvatar} className="ai-avatar" alt="AI Avatar" />
                <div className={`message ${m.sender}`}>
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      [rehypeExternalLinks, { target: "_blank", rel: ["noopener", "noreferrer"] }],
                    ]}
                    components={markdownComponents}
                  >
                    {linkify(m.text)}
                  </ReactMarkdown>
                </div>
              </>
            )}

            {m.sender === "user" && (
              <>
                <div className={`message ${m.sender}`}>
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      [rehypeExternalLinks, { target: "_blank", rel: ["noopener", "noreferrer"] }],
                    ]}
                    components={markdownComponents}
                  >
                    {linkify(m.text)}
                  </ReactMarkdown>
                </div>
                <img src={userAvatar} className="user-avatar" alt="User Avatar" />
              </>
            )}
          </div>
        ))}

        {isThinking && (
          <div className="message-row ai">
            <img src={aiAvatar} className="ai-avatar" alt="AI Avatar" />
            <div className="message ai typing-indicator">
              <span>Typing</span>
              <span className="dot dot1">.</span>
              <span className="dot dot2">.</span>
              <span className="dot dot3">.</span>
            </div>
          </div>
        )}
      </div>

      <div className="chat-input">
        <input
          type="file"
          accept="image/*"
          id="imageUpload"
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const url = URL.createObjectURL(file);
              setMessages((prev) => [
                ...prev,
                { sender: "user", text: "[Image uploaded]", image: url },
              ]);
              logMessage({
                role: "user",
                content: "[Image uploaded]",
                meta: { image: true, filename: file.name },
              });
            }
          }}
        />

        <button
          title="Upload Image"
          className="image-upload-btn"
          onClick={() => document.getElementById("imageUpload").click()}
        >
          <img src={imageIcon} alt="Upload" className="chat-icon2" />
        </button>

        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
          placeholder="Type a message here"
        />

        <button onClick={handleSend} disabled={isThinking || !sessionId}>
          ➤
        </button>
      </div>

      <div className="chat-footer">
        Powered by Olumis AI
      </div>
    </div>
  );
}